import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { getMaintainance } from "../../api/apimethods"

const SystemMaintenance: React.FC = () => {
  const [maintenanceMsg, setMaintenanceMsg] = useState<string | null>(null);

  useEffect(() => {
    const fetchMaintenance = async () => {
      try {
          const data = await getMaintainance();
        if (data.status) {
          setMaintenanceMsg(data.message);
        } else {
          setMaintenanceMsg(null);
        }
      } catch (err) {
        console.error("Error fetching maintenance info:", err);
      }
    };

    fetchMaintenance();

    // optional refresh every few minutes
    const interval = setInterval(fetchMaintenance, 1 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (!maintenanceMsg) return null;

  const safeMaintenanceMsg = DOMPurify.sanitize(maintenanceMsg);

  return (

    <div id="scamNotification" className="systemmaintenance"  dangerouslySetInnerHTML={{ __html: safeMaintenanceMsg }}/>
    
    
  );
};

export default SystemMaintenance;
